"use strict";
/**
 * RD-10 / RD-12 (report 134, approved by Paul): every number on Home taps through to the
 * one page that owns it, and to the row on that page. Shared under rule 17 so both apps
 * open the same thing; agreed with mobile 2026-10-15.
 *
 * Shared: which page owns a target, the query that names the row, and the row-id
 * formats both apps' page readers parse. NOT shared: paths. Web and mobile route
 * differently (mobile's debt page is `/debt-eliminator` under `/(drawer)`), so each app
 * maps `ownerPage` onto its own path.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWNER_ROW_FOUND = void 0;
exports.goalRowId = goalRowId;
exports.debtRowId = debtRowId;
exports.bucketRowId = bucketRowId;
exports.groupRowId = groupRowId;
exports.parseOwnerRow = parseOwnerRow;
exports.ownerPage = ownerPage;
exports.ownerQuery = ownerQuery;
exports.readOwnerParams = readOwnerParams;
/** The `row` value for the "debts we found" section on the debt page. */
exports.OWNER_ROW_FOUND = "found";
function goalRowId(id) {
    return `goal-${id}`;
}
function debtRowId(id) {
    return `debt-${id}`;
}
function bucketRowId(key) {
    return `bucket:${key}`;
}
/** A group on Plan (its display group key, e.g. `savings_goals`). */
function groupRowId(key) {
    return `group:${key}`;
}
/** A `row` value back into what it names; anything else is null (ignored). */
function parseOwnerRow(row) {
    if (!row)
        return null;
    if (row === exports.OWNER_ROW_FOUND)
        return { kind: "found" };
    const goal = /^goal-(\d+)$/.exec(row);
    if (goal)
        return { kind: "goal", id: goal[1] };
    const debt = /^debt-(\d+)$/.exec(row);
    if (debt)
        return { kind: "debt", id: debt[1] };
    const bucket = /^bucket:([a-z0-9_-]+)$/i.exec(row);
    if (bucket)
        return { kind: "bucket", key: bucket[1] };
    const group = /^group:([a-z_]+)$/.exec(row);
    if (group)
        return { kind: "group", key: group[1] };
    return null;
}
function ownerPage(target) {
    switch (target.kind) {
        case "transaction":
            return "transactions";
        case "day":
            return "calendar";
        case "debt":
        case "debts-found":
            return "debt";
        // Retired pages (Paul, 2026-10-29): a goal and an Allocate bucket open Plan.
        case "goal":
        case "bucket":
        case "plan-group":
        case "plan-bucket":
        case "plan-checkin":
        case "plan-setup":
        case "plan":
            return "plan";
    }
}
/** The query naming the row, without "?": e.g. "txn=12", "row=bucket:splash". Plan's top
 *  (`{kind: "plan"}`) has none: "". */
function ownerQuery(target) {
    switch (target.kind) {
        case "transaction":
            return `txn=${encodeURIComponent(String(target.id))}`;
        case "day":
            return `date=${encodeURIComponent(target.date)}`;
        // Plan has no goal rows: a goal opens its group, Savings & goals.
        case "goal":
            return `row=${encodeURIComponent(groupRowId("savings_goals"))}`;
        case "debt":
            return `row=${debtRowId(target.id)}`;
        case "debts-found":
            return `row=${exports.OWNER_ROW_FOUND}`;
        case "bucket":
            return `row=${encodeURIComponent(bucketRowId(target.key))}`;
        case "plan-bucket":
            return `row=${encodeURIComponent(bucketRowId(target.key))}${target.info ? "&info=1" : ""}`;
        case "plan-group":
            return `row=${encodeURIComponent(groupRowId(target.key))}`;
        case "plan-checkin":
            return "open=checkin";
        case "plan-setup":
            return "open=setup";
        case "plan":
            return "";
    }
}
/**
 * What a destination page should open. Each value is validated; an invalid or unknown
 * one is null, and the page opens normally (a stale link never errors).
 */
function readOwnerParams(search) {
    const params = new URLSearchParams(search);
    const txn = params.get("txn");
    const date = params.get("date");
    const row = params.get("row");
    const open = params.get("open");
    return {
        txn: txn !== null && /^\d+$/.test(txn) ? txn : null,
        date: date !== null && /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : null,
        row: parseOwnerRow(row) ? row : null,
        info: params.get("info") === "1",
        open: open === "checkin" || open === "setup" ? open : null,
    };
}
//# sourceMappingURL=ownerLink.js.map